import {FairBanner} from './banner';
import {HighLightBusiness} from './business';
import {HighLightPromotion} from './promotion';
import {FairListProduct} from './list';

export {
  FairBanner ,
  HighLightBusiness,
  HighLightPromotion,
  FairListProduct
}


// WEBPACK FOOTER //
// ./components/fair/sub-view/index.js